export const DEFAULT_THEME = {
    primaryColor: '#751273',
    accentColor: '#819b13',
    warnColor: '#910000'
}